module.exports = __webpack_public_path__ + "img/uspsLogo.3ed0724b.png";